<template>
  <a-drawer
    width="35%"
    :label-col="4"
    :wrapper-col="14"
    :visible="open"
    @close="onClose"
  >
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-descriptions title="参数信息">
      <a-descriptions-item label="参数名称">{{ paramName }}</a-descriptions-item>
      <!--      <a-descriptions-item label="参数编码">{{paramCode}}</a-descriptions-item>-->
    </a-descriptions>
    <a-form-model
      ref="form"
      :model="form"
      :rules="rules"
    >
      <a-form-model-item
        label="最小安全值"
        prop="limitMin"
      >
        <a-input-number
          v-model="form.limitMin"
          style="width: 80%;"
          placeholder="请输入最小安全值"
          :maxLength="30"
        />
        <span style="width: 20%;padding-left: 10px;">{{ unit }}</span>
      </a-form-model-item>
      <a-form-model-item
        label="最大安全值"
        prop="limitMax"
      >
        <a-input-number
          v-model="form.limitMax"
          style="width: 80%;"
          :maxLength="30"
          placeholder="请输入最大安全值"
        />
        <span style="width: 20%;padding-left: 10px;">{{ unit }}</span>
      </a-form-model-item>
      <a-form-model-item
        label="备注"
        prop="remark"
      >
        <a-input
          type="textarea"
          v-model="form.remark"
          placeholder="请输入备注"
          :maxLength="50"
        />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button
            type="primary"
            :loading="submitLoading"
            @click="submitForm"
          >
            保存
          </a-button>
          <a-button
            type="dashed"
            @click="cancel"
          >
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getSetup, addSetup, updateSetup } from '@/api/saifuneng/setup'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      unit: '',
      paramName: '',
      paramCode: '',
      // 表单参数
      form: {
        id: null,
        limitMin: null,
        limitMax: null,
        remark: null
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        limitMin: [
          { required: true, message: '最小安全值不能为空', trigger: 'blur' }
        ],
        limitMax: [
          { required: true, message: '最大安全值不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {

  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        limitMin: null,
        limitMax: null,
        remark: null
      }
      this.$nextTick(() => {
        this.$refs.form.resetFields()
      })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getSetup({ "id": id }).then(response => {
        this.paramName = response.data.name
        this.paramCode = response.data.code
        this.form = response.data
        this.open = true
        this.formTitle = '修改'
        this.getUnit(response.data.type, response.data.code)
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateSetup(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addSetup(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    },
    // 获取单位
    getUnit (type, code) {
      if (type === 1) {
        if (code == 'battery_voltage') {
          // 电池电压
          this.unit = 'V'
        } else if (code == 'traffic_balance') {
          // 流量余额
          this.unit = 'MB'
        } else if (code == 'electrified_potential') {
          // 通电电位
          this.unit = 'V'
        } else if (code == 'voff') {
          // 断电电位
          this.unit = 'V'
        } else if (code == 'ac_voltage') {
          // 交流电压
          this.unit = 'V'
        }
      } else if (type === 2) {
        //
      } else if (type === 3) {
        //
      } else if (type === 4) {
        //
      }

    }


  }
}
</script>
